// extracted by mini-css-extract-plugin
module.exports = {"container":"i_Cg","inherit":"i_Ch","truncated":"i_Ci"};